/**
 * AUTO-GENERATED by scripts/generate-locale-registry.js — do not edit.
 * Add locales/<code>/… and run: npm run generate-locales (or npm run validate-keys).
 */
import enCommon from './en/common.json'
import enAdmin from './en/admin.json'
import enErrors from './en/errors.json'
import esCommon from './es/common.json'
import esAdmin from './es/admin.json'
import esErrors from './es/errors.json'
import frCommon from './fr/common.json'
import frAdmin from './fr/admin.json'
import frErrors from './fr/errors.json'
import nlCommon from './nl/common.json'
import nlAdmin from './nl/admin.json'
import nlErrors from './nl/errors.json'

const localeResources = {
  en: {
    common: enCommon,
    admin: enAdmin,
    errors: enErrors,
  },
  es: {
    common: esCommon,
    admin: esAdmin,
    errors: esErrors,
  },
  fr: {
    common: frCommon,
    admin: frAdmin,
    errors: frErrors,
  },
  nl: {
    common: nlCommon,
    admin: nlAdmin,
    errors: nlErrors,
  },
} as const

export default localeResources

export type SupportedLocale = keyof typeof localeResources
